module.exports = __webpack_public_path__ + "img/grain.528b8a7a.png";